import {
  Tab, TabList, TabPanel, TabPanels, Tabs,
} from '@chakra-ui/react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import ChangePassword from './ChangePassword';
import EditProfile from './EditProfile';

const tabMap: Record<string, number> = {
  'my-profile': 0,
  'change-password': 1,
};
function SettingsPage(): JSX.Element {
  const { tabName } = useParams<{ tabName: string }>();
  return (
    <Tabs
      index={tabMap[tabName || 'my-profile']}
      variant='soft-rounded'
      size='lg'
    >
      <TabList>
        <Link to='/settings/my-profile'>
          <Tab>My Profile</Tab>
        </Link>
        <Link to='/settings/change-password'>
          <Tab>Change Password</Tab>
        </Link>
      </TabList>
      <TabPanels>
        <TabPanel>
          <EditProfile />
        </TabPanel>
        <TabPanel>
          <ChangePassword />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}

export default SettingsPage;
